export default function getTargetDivCSSSelector(target: HTMLElement | undefined): string | null {
    return target?.attributes['data-calitemid']?.value && target.dataset && target.dataset.itemindex
        ? `div[data-calitemid="${target?.attributes['data-calitemid'].value}"][data-itemindex="${target.dataset.itemindex}"]`
        : null;
}
